module.exports = __webpack_public_path__ + "img/disableplus.007cc014.svg";